export const selectIsLoggedIn = (state) => state.auth.isLoggedIn;

export const selectToken = (state) => state.auth.token;

export const selectRole = (state) => state.auth.role;

export const selectIsRefreshing = (state) => state.auth.isRefreshing;
